import React from 'react'
import { useSelector } from 'react-redux'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'

import { getIncludedItemsCount } from '../../../helpers'

const Seasons = () => {
  const {
    criteria: {
      seasons: { includeOrExclude, selectedItems }
    },
    data: {
      seasons: { items: allSeasons }
    }
  } = useSelector(state => state)

  const count = getIncludedItemsCount(
    includeOrExclude,
    allSeasons.length,
    selectedItems.length
  )

  return (
    <ListItem dense disableGutters>
      <ListItemText>Seasons:</ListItemText>
      <ListItemSecondaryAction>
        {`${count.toLocaleString()} / ${allSeasons.length} included`}
      </ListItemSecondaryAction>
    </ListItem>
  )
}

export default Seasons
